import { Component } from '@angular/core';

@Component({
  selector: 'lib-error-page',
  imports: [],
  template: `
    <p>
      error-page works!
    </p>
  `,
  styles: ``
})
export class ErrorPage {

}
